/*
 * Per-product gift wrap in the cart (separate ₹50-per-unit line, shown indented
 * under its product).
 *  - The product's "Gift wrap" checkbox adds a Gift Wrapping line linked to it
 *    via a `_for` property, with quantity = the product's quantity.
 *  - The ✕ on the indented add-on line removes that gift wrap line.
 *  - A reconciler keeps each gift-wrap line's quantity equal to its product's
 *    quantity (so ₹50 × quantity), even when the quantity is changed in the cart.
 * Delegated, so it survives cart re-renders.
 */
(function () {
  if (window.__cartGiftWrapInit) return;
  window.__cartGiftWrapInit = true;

  var GIFT_WRAP_VARIANT = 47634012733630;

  function cartElement() {
    return (
      document.querySelector('cart-items') ||
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification')
    );
  }

  function sectionsToRender(cart) {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-icon-bubble'];
  }

  function applyRender(cart, data) {
    try {
      if (cart && data.sections && typeof cart.renderContents === 'function') {
        cart.renderContents(data);
      } else {
        window.location.reload();
      }
    } catch (err) {
      window.location.reload();
    }
  }

  function post(url, body, cart, onError) {
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { if (onError) onError(); return; }
        applyRender(cart, res.data);
      })
      .catch(function () { if (onError) onError(); });
  }

  // Add gift wrap (quantity = the product's quantity) by ticking the checkbox.
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-line-giftwrap]');
    if (!cb || !cb.checked) return;
    cb.disabled = true;
    var row = cb.closest('tr');
    var qtyInput = row && row.querySelector('.quantity__input');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    var cart = cartElement();
    post(
      '/cart/add.js',
      {
        id: GIFT_WRAP_VARIANT,
        quantity: qty,
        properties: {
          _for: cb.getAttribute('data-product-key'),
          For: cb.getAttribute('data-product-title')
        },
        sections: sectionsToRender(cart),
        sections_url: window.location.pathname
      },
      cart,
      function () { cb.checked = false; cb.disabled = false; }
    );
  });

  // Remove gift wrap via the ✕ on the indented add-on line.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-giftwrap-remove]');
    if (!btn) return;
    e.preventDefault();
    var wrapKey = btn.getAttribute('data-wrap-key');
    if (!wrapKey) return;
    btn.setAttribute('aria-disabled', 'true');
    var cart = cartElement();
    post(
      '/cart/change.js',
      { id: wrapKey, quantity: 0, sections: sectionsToRender(cart), sections_url: window.location.pathname },
      cart,
      function () { btn.removeAttribute('aria-disabled'); }
    );
  });

  // Keep each gift-wrap line's quantity equal to its product's quantity.
  var reconciling = false;
  function reconcile() {
    if (reconciling) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var byKey = {};
        var byToken = {};
        var byTitle = {};
        cart.items.forEach(function (it) {
          if (it.handle === 'gift-wrapping') return;
          byKey[it.key] = it.quantity;
          if (it.properties && it.properties._wrap_id) byToken[it.properties._wrap_id] = it.quantity;
          if (it.product_title) byTitle[it.product_title] = it.quantity;
        });

        var fix = null;
        for (var i = 0; i < cart.items.length; i++) {
          var gw = cart.items[i];
          if (gw.handle !== 'gift-wrapping' || !gw.properties) continue;
          var ref = gw.properties._for;
          var forTitle = gw.properties.For;
          var parentQty = null;
          if (ref != null && byKey.hasOwnProperty(ref)) parentQty = byKey[ref];
          else if (ref != null && byToken.hasOwnProperty(ref)) parentQty = byToken[ref];
          else if (forTitle != null && byTitle.hasOwnProperty(forTitle)) parentQty = byTitle[forTitle];
          if (parentQty !== null && parentQty !== gw.quantity) {
            fix = { key: gw.key, qty: parentQty };
            break;
          }
        }
        if (!fix) return;

        reconciling = true;
        var cartEl = cartElement();
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: fix.key,
            quantity: fix.qty,
            sections: sectionsToRender(cartEl),
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) { applyRender(cartEl, data); })
          .catch(function () {})
          .then(function () { reconciling = false; });
      })
      .catch(function () {});
  }

  function watchCart() {
    var targets = [
      document.querySelector('cart-items'),
      document.querySelector('cart-drawer'),
      document.querySelector('cart-notification')
    ].filter(Boolean);
    if (!targets.length) return;
    var timer;
    var obs = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(reconcile, 250);
    });
    targets.forEach(function (el) { obs.observe(el, { childList: true, subtree: true }); });
  }

  function init() {
    reconcile();
    watchCart();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
